/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Ok_ButtonInputs */

const en_iframe_remote_ok_button = /** @type {(inputs: Iframe_Remote_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const fr_iframe_remote_ok_button = /** @type {(inputs: Iframe_Remote_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const de_iframe_remote_ok_button = /** @type {(inputs: Iframe_Remote_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const it_iframe_remote_ok_button = /** @type {(inputs: Iframe_Remote_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ru_iframe_remote_ok_button = /** @type {(inputs: Iframe_Remote_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ХОРОШО`)
};

const es_iframe_remote_ok_button = /** @type {(inputs: Iframe_Remote_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DE ACUERDO`)
};

const zh_cn2_iframe_remote_ok_button = /** @type {(inputs: Iframe_Remote_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`好的`)
};

const ja_iframe_remote_ok_button = /** @type {(inputs: Iframe_Remote_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`わかりました`)
};

const hi_iframe_remote_ok_button = /** @type {(inputs: Iframe_Remote_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठीक है`)
};

const pt_pt2_iframe_remote_ok_button = /** @type {(inputs: Iframe_Remote_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

/**
* | output |
* | --- |
* | "OK" |
*
* @param {Iframe_Remote_Ok_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_ok_button = /** @type {((inputs?: Iframe_Remote_Ok_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Ok_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_ok_button(inputs)
	if (locale === "de") return de_iframe_remote_ok_button(inputs)
	if (locale === "it") return it_iframe_remote_ok_button(inputs)
	if (locale === "ru") return ru_iframe_remote_ok_button(inputs)
	if (locale === "es") return es_iframe_remote_ok_button(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_ok_button(inputs)
	if (locale === "ja") return ja_iframe_remote_ok_button(inputs)
	if (locale === "hi") return hi_iframe_remote_ok_button(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_ok_button(inputs)
	return en_iframe_remote_ok_button(inputs)
});